// 首页会员服务
$.ajax({
    url: '/api/admin/official/exc/memberService',
    type: 'GET',
    // beforeSend: function (res) {
    //   res.setRequestHeader('terminalType', 2)
    // },
    data: {terminalType: 2},
    dataType: 'json',
    success: function(res) {
        const list = res.data
        let bgList = ''
        let contents = ''     
        $.each(list, function(i) {
            bgList = `<img src=${list[i].imgUrl} />`
            $('#thirdlBackgroundImg').append(bgList)
            contents += 
                    `<li>
                        <div class="item clearfix">
                            <div class="img_ar">
                                <img src= ${list[i].imgUrl} />
                            </div>
                            <div class="cont_ar">
                                <h3> ${list[i].optionsName} </h3>
                                <div class="dec_ar">
                                    <div class="acr_p">
                                        <span class="title"> ${list[i].optionsName} </span>
                                        <div class="view-details">
                                            <a href="member.html?idx=0&id=${list[i].optionsId}&name=${list[i].optionsName}">查看详情</a>
                                            <img src="/static/images/more-icon-2.png" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>`
            $(".member-ui").html(contents)
        })
    }
})
